import { AfterViewInit, Component, OnInit } from '@angular/core';
import AutocompleteUiComponent from '@iupics-components/standard/fields/autocomplete-ui/autocomplete-ui.component';
import { DataStoreService } from '@iupics-manager/managers/data-store/data-store.service';
import { WindowFactoryUtils } from '@iupics-manager/managers/ui-creator/window-factory/window-factory-utils';
import { AbstractDynamicComponent } from '@iupics-manager/models/abstract-dynamic-component';
import { Global } from '@iupics-manager/models/global-var';
import { IupicsEvent } from '@iupics-manager/models/iupics-event';
import { DynamicContainerDirective } from '../../../../iupics-util/directives/dynamic-container.directive';

// TODO: refactor des forms à prévoir pour pouvoir supprimer ce component
@Component({
  selector: 'iu-row-ui',
  templateUrl: './row-ui.component.html',
  styleUrls: ['./row-ui.component.css'],
  standalone: true,
  imports: [DynamicContainerDirective],
})
export default class RowUiComponent extends AbstractDynamicComponent implements OnInit, AfterViewInit {
  constructor(private dataStoreService: DataStoreService) {
    super();
  }

  ngOnInit(): void {
    Global.startPerf(this);
  }

  ngAfterViewInit(): void {
    for (const child of this.children) {
      const componentRef = WindowFactoryUtils.addContainerComponent({
        parent: this,
        item: child,
        isCssOnComponent: child.container ? child.isCssOnComponent : false,
      });
      if (componentRef.instance instanceof AutocompleteUiComponent) {
        (componentRef.instance as AutocompleteUiComponent).itemData = child;
      }
    }
    Global.endPerf(this, '');
  }

  onChildUpdate(event: IupicsEvent): void {}

  onSiblingUpdate(event: IupicsEvent): void {}

  onRemoveComponent(event: IupicsEvent): void {}
}
